import { RootState } from '../../types';

export const all = (state: RootState) => state.auth.register;
export const loading = (state: RootState) => all(state).loading;
export const error = (state: RootState) => all(state).error;
export const isSuccess = (state: RootState) => state.auth.register.isSuccess;
